module.exports = __webpack_public_path__ + "img/61.ca9115f3.png";